import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Upload, LayoutTemplate } from 'lucide-react';

/**
 * Segmented control shown at the top of the Uploaded Invoices area.
 * Lets the user switch between their invoices and the templates that
 * improve how those invoices are read.
 */
const InvoicesSubNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onTemplates = location.pathname.startsWith('/uploaded-invoices/templates');

  const tabClass = (active: boolean) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2 ${
      active
        ? 'bg-coral-500/30 text-foreground shadow-sm'
        : 'text-foreground-muted hover:text-foreground-secondary hover:bg-coral-500/10'
    }`;

  return (
    <div className="flex justify-center pt-6">
      <div className="inline-flex p-1 bg-coral-500/10 rounded-xl gap-1">
        <button onClick={() => navigate('/uploaded-invoices')} className={tabClass(!onTemplates)}>
          <Upload className="w-4 h-4" />
          <span>Invoices</span>
        </button>
        <button onClick={() => navigate('/uploaded-invoices/templates')} className={tabClass(onTemplates)}>
          <LayoutTemplate className="w-4 h-4" />
          <span>Templates</span>
        </button>
      </div>
    </div>
  );
};

export default InvoicesSubNav;
